<template>
  <el-card class="box-card c-accreditation__card">
    <div class="c-accreditation__wrapper c-accreditation__wrapper--quadruple">
      <div class="c-accreditation__wrapper-title">
        <h3
          class="
            c-accreditation__title
            c-text--medium c-text--transform-upper c-text--align-center
          "
          :class="statusDescription.cssClass"
        >
          <template
            v-if="
              !statusDescription.statusId ||
              Number(statusDescription.statusId) === 4
            "
          >
            {{ prefixes.title }} </template
          >{{ statusDescription.title }}
        </h3>
      </div>

      <div
        v-for="button in buttons"
        :key="button.title"
        class="c-accreditation__wrapper-btn"
      >
        <el-button
          class="c-accreditation__btn c-accreditation__btn--full"
          :type="button.type"
          :title="button.title"
          @click="changeApproveStatus(button.nextStatusId)"
        >
          {{ button.title }}
        </el-button>
      </div>
      <div v-if="masterApproveComment" class="c-accreditation__wrapper-text">
        <p class="c-accreditation__text">
          {{ entity['master-approve'].comment }}
        </p>
      </div>
    </div>
  </el-card>
</template>
<script>
import { approveStatuses, checkFailStatuses } from './statusDescription'
import { mapGetters } from 'vuex'

export default {
  inject: [
    'permitToSeeActions',
    'createListOfButtons',
    'defaultButtons',
    'initStatusId',
  ],
  props: {
    entity: {
      type: Object,
      required: true,
    },
    linkByRel: {
      type: String,
      required: true,
    },
    prefixes: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      buttons: {},
      statusDescription: {},
    }
  },
  computed: {
    ...mapGetters({ user: 'userProfile/userInfo' }),
    masterApproveComment() {
      return (
        this.masterApproveNotNull() &&
        checkFailStatuses(this.entity['master-approve'].status) &&
        String(this.entity['master-approve'].comment).trim()
      )
    },
  },
  watch: {
    entity: {
      deep: true,
      handler() {
        this.init()
      },
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.buttons = this.visibleButtonsList()
      this.statusDescription = this.approveStatus()
    },
    visibleButtonsList() {
      let buttons = []

      if (this.masterApproveNotNull()) {
        buttons = this.createListOfButtons(this.entity['master-approve'].status)
      } else {
        buttons = this.defaultButtons(this.initStatusId, buttons)
      }

      return buttons
    },
    approveStatus() {
      let statusId = this.masterApproveNotNull()
        ? this.entity['master-approve'].status
        : this.initStatusId

      return approveStatuses.find(
        item => Number(item.statusId) === Number(statusId),
      )
    },
    changeApproveStatus(nextStatusId) {
      const params = {
        link_by_id: this.entity.id,
        create_master_approve: 1,
        link_by_rel: this.linkByRel,
        status: nextStatusId,
        user_org_inn: Number(this.user.current.organization.inn),
      }

      this.$emit('update', params, {
        fieldToUpdate: 'approve_master',
      })
    },
    masterApproveNotNull() {
      return 'master-approve' in this.entity && this.entity['master-approve']
    },
  },
}
</script>

<style lang="scss" scope>
.el-card__body {
  padding: 10px;
}
</style>
